<template>
  <ais-configure
    v-bind="$attrs"
    :hitsPerPage="hitsPerPage"
    :facets="uniqueFacets"
    :filters="innerFilters"
    :attributesToRetrieve="attributesToRetrieve"
  />
</template>

<script>
import {getLangcode} from '../main/utils';

export default {
  name: 'SloConfigure',
  props: {
    hitsPerPage: {type: Number},
    filters: {type: String, default: ''},
    facets: {type: Array, default: () => []},
    attributesToRetrieve: {type: Array, default: () => ['*']}
  },
  computed: {
    uniqueFacets() {
      let results = [];
      for (const facet of ['search_api_language'].concat(this.facets)) {
        if (!results.includes(facet)) results.push(facet);
      }
      return results;
    },
    langcode() {
      return getLangcode(this.$route.params.langcode);
    },
    innerFilters() {
      return this.filters
        ? `(search_api_language:${this.langcode}) AND ${this.filters}`
        : `(search_api_language:${this.langcode})`;
    }
  }
};
</script>
